<template>
  <BaseModal
    class="modal--md"
    :title="getTitle"
    @close="onReject"
  >
    <div class="w-100 column gap-s">
      <InfoTextBlock label-text="Материал" :text="getMaterialName" />
      <InfoTextBlock label-text="d пров." :text="dWire" />
      <InfoTextBlock label-text="Длина развертки" :text="sweepLength" />
      <div
        v-for="row in consignment.dirty_weights" :key="row.id"
        class="d-flex gap-l p-10 section--gray w-max-max"
      >
        <InfoTextBlock label-text="Метраж" :text="getLength(row)" />
        <InfoTextBlock :label-text="'Общий вес на ' + (row.count || 0) + ' шт. изд.'" :text="row.weight_dirty || '-'" />
      </div>
    </div>

  </BaseModal>
</template>

<script>
import BaseModal from '@/components/ui/Modal/BaseModal.vue'
import InfoTextBlock from '@/components/ui/AppInfoTextBlock.vue'

export default {
  name: 'ModalConsignmentShowWeightDirty',
  components: {
    InfoTextBlock,
    BaseModal
  },

  props: {
    consignment: {
      type: Object,
      required: true
    },
    position: {
      type: Object,
      required: true
    }
  },

  computed: {
    getMaterialName () {
      return this.position?.material?.name ?? '-'
    },

    dWire () {
      return this.position?.d_wire ?? '-'
    },

    sweepLength () {
      return this.position?.sweep_length ?? '-'
    },

    getTitle () {
      return 'Общий вес партии №' + this.consignment.sort
        + (this.consignment?.weight_dirty ? ': ' + this.consignment.weight_dirty : '')
    }
  },

  methods: {
    onReject () {
      this.$emit('reject')
    },
    getLength (row) {
      return row?.material_document?.warehouse_material?.length || '-'
    }
  }
}
</script>
